import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FacultyDashboard from "../Components/SchoolAdmin/FacultyDashboard";
import CreateFacultyTheme from "../Components/SchoolAdmin/CreateFacultyTheme";
import FacultyEventList from "../Components/SchoolAdmin/FacultyEventList";
import FacultyEcoCalendar from "../Components/SchoolAdmin/FacultyEcoCalendar";
import EventAssignment from "../Components/SchoolAdmin/EventAssignment";
import FacultyManagement from "Components/SchoolAdmin/FacultyManagement";
import OutletRouteFaculty from "../Components/OutletRouteFaculty";
import SetLanguage from "../Components/SchoolAdmin/SetLanguage"
import FacultyEventManagement from "../Components/SchoolAdmin/FacultyEventManagement";
import Notification from "Components/SchoolAdmin/Notification";
import FacultyPasswordUpdate from "../Pages/FacultyPasswordUpdate";
import { useSelector } from "react-redux";
import RoleGuard from "../Components/RoleGuard";


function FacultyRoutingPage() {

    const userData = useSelector(state => state.auth.user);
    const userRole = userData?.role;
    console.log('inside faculty routing', userData);

    return (
        <>
            {/* <Router> */}
                <Routes>
                    <Route path="/faculty/password" element={<RoleGuard allowedRoles={[3]}><FacultyPasswordUpdate /></RoleGuard>} />
                    <Route path="/faculty" element={<RoleGuard allowedRoles={[3]}><OutletRouteFaculty /></RoleGuard>}>
                        <Route index element={<FacultyDashboard />} />
                        <Route path="createtheme" element={<CreateFacultyTheme />} />
                        <Route path="eventmanagement" element={<FacultyEventManagement />} />
                        <Route path="eventlist" element={<FacultyEventList />} />
                        <Route path="ecocalendar" element={<FacultyEcoCalendar />} />
                        <Route path="school/*" element={<Navigate to="/faculty" replace />} />
                    </Route>
                    {userRole === 3 && (
                        <Route path="admin/*" element={<Navigate to="/school" replace />} />
                    )}
                </Routes>
        </>
    );
}

export default FacultyRoutingPage;
